import React from "react";

export function ArmBoldIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 70 70"
      width="30"
      height="30"
      {...props}
    >
      <path
        className="cls-1"
        d="m41.56,51.42c-2.02,0-3.99-.76-5.49-2.13-1.67-1.53-2.63-3.71-2.63-5.97v-14.94c0-2.82-1.99-5.21-4.54-5.43-1.43-.12-2.78.33-3.82,1.29-1.03.94-1.62,2.28-1.62,3.68v18.01h-3.11v-18.01c0-2.26.96-4.44,2.63-5.97,1.67-1.53,3.93-2.28,6.2-2.1,4.14.36,7.38,4.11,7.38,8.53v14.94c0,1.39.59,2.74,1.62,3.68,1.04.95,2.4,1.4,3.82,1.29,2.55-.22,4.54-2.61,4.54-5.44v-16.47h3.11v16.47c0,4.42-3.24,8.18-7.38,8.53-.24.02-.47.03-.7.03Z"
      />
      <path
        className="cls-1"
        d="m35,70C15.7,70,0,54.3,0,35S15.7,0,35,0s35,15.7,35,35-15.7,35-35,35Zm0-66.89C17.42,3.11,3.11,17.42,3.11,35s14.31,31.89,31.89,31.89,31.89-14.3,31.89-31.89S52.58,3.11,35,3.11Z"
      />
    </svg>
  );
}
